export default __webpack_public_path__ + "img/InterDisplay-BoldItalic_96daac8.woff2";